import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { FilledTooltips, TooltipInfo } from "../../../../Constant";
import { FILL_TOOLTIP_DATA, FILL_TOOLTIP_LIST } from "../../../../Data/UiKit/Tooltip";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonTooltip from "../Common/CommonTooltip";

const FilledTooltip = () => {
    const [tooltip, setTooltip] = useState(false);
    const toggle = () => setTooltip(!tooltip);
    return (
      <Col md="6">
        <Card>
          <CommonCardHeader title={FilledTooltips} span={FILL_TOOLTIP_DATA} />
          <CardBody>
            <div className="common-flex">
              <Btn outline color="info" id="Tooltip-16" className="mb-0 me-0">{TooltipInfo}</Btn>
              <ToolTip isOpen={tooltip} toggle={toggle} placement="top" target="Tooltip-16">
              Tooltip Primary
              </ToolTip>
              {FILL_TOOLTIP_LIST.map((data) => (
                <CommonTooltip key={data.id} outline={true} item={data} />
              ))}
            </div>
          </CardBody>
        </Card>
      </Col>
    )
};

export default FilledTooltip;
